import { frontendURL } from '../../../../helper/URLHelper';
import {
  AUTOMATION_MANAGE_PERMISSIONS,
  AUTOMATION_VIEW_PERMISSIONS,
  AUTOMATION_VIEW_ALL_PERMISSIONS,
  AUTOMATION_CREATE_PERMISSIONS,
  AUTOMATION_EDIT_PERMISSIONS,
  AUTOMATION_DELETE_PERMISSIONS,
  AUTOMATION_PUBLISH_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import { FLOW_VERSION_ROUTE } from 'dashboard/helper/flowVersionLabel';

const SettingsWrapper = () => import('../SettingsWrapper.vue');
const FlowsIndex = () => import('./Index.vue');
const FlowEditor = () => import('./FlowEditor.vue');
const FlowVersionView = () => import('./FlowVersionView.vue');

// A autorização fina (pessoal vs global, autoria, publish) é da
// AutomationFlowPolicy no backend; a rota só decide quem enxerga a tela.
export const FLOW_SCREEN_PERMISSIONS = [
  'administrator',
  AUTOMATION_MANAGE_PERMISSIONS,
  AUTOMATION_VIEW_PERMISSIONS,
  AUTOMATION_VIEW_ALL_PERMISSIONS,
  AUTOMATION_CREATE_PERMISSIONS,
  AUTOMATION_EDIT_PERMISSIONS,
  AUTOMATION_DELETE_PERMISSIONS,
  AUTOMATION_PUBLISH_PERMISSIONS,
];

export const FLOW_CREATE_PERMISSIONS = [
  'administrator',
  AUTOMATION_MANAGE_PERMISSIONS,
  AUTOMATION_CREATE_PERMISSIONS,
];

// Exportada para quem linka para o editor de fora dele (listagem de execuções da
// conversa/contato, #1705): link para rota que o usuário não abre é link quebrado.
export const FLOW_EDIT_PERMISSIONS = [
  'administrator',
  AUTOMATION_MANAGE_PERMISSIONS,
  AUTOMATION_EDIT_PERMISSIONS,
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/automations/flows'),
      component: SettingsWrapper,
      children: [
        { path: '', redirect: 'list' },
        {
          path: 'list',
          name: 'automation_flows_list',
          component: FlowsIndex,
          meta: {
            permissions: FLOW_SCREEN_PERMISSIONS,
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/automations/flows/new'),
      name: 'automation_flows_new',
      component: FlowEditor,
      meta: {
        permissions: FLOW_CREATE_PERMISSIONS,
      },
    },
    {
      path: frontendURL('accounts/:accountId/automations/flows/:flowId/edit'),
      name: 'automation_flows_edit',
      component: FlowEditor,
      meta: {
        permissions: FLOW_EDIT_PERMISSIONS,
      },
    },
    // O fluxo como estava numa versão publicada, SOMENTE LEITURA (#1705). Rota e
    // componente próprios, e não um modo do FlowEditor: o editor é dono de todo
    // caminho de escrita do fluxo (salvar, publicar, testar), e a única forma
    // de garantir que o grafo antigo nunca seja gravado por cima do rascunho é
    // ele não chegar ao editor. Mesmas permissões da edição: quem chega aqui vem
    // de dentro do editor ou de um link que exige poder abri-lo.
    {
      path: frontendURL(
        'accounts/:accountId/automations/flows/:flowId/versions/:versionId'
      ),
      name: FLOW_VERSION_ROUTE,
      component: FlowVersionView,
      meta: {
        permissions: FLOW_EDIT_PERMISSIONS,
      },
    },
  ],
};
